import {
    PERSON_RECEIVE,
    PERSON_ERROR,
    PERSON_CHANGE_MODE,
    ADDRESS_RECEIVE,
    ADDRESS_ERROR,
    ADDRESS_CHANGE_MODE,
    ORDER_RECEIVE,
    ORDER_ERROR,
    ORDER_CHANGE_MODE,
    ORDER_CHANGE_CURRENTPAGE,
    ORDER_SET_ORDER,
} from '../constants';

import {
    ACTIVE_CONSUMER_ORDER_RECEIVE,
    ACTIVE_CONSUMER_ORDER_ERROR,
    ACTIVE_CONSUMER_ORDER_CHANGE_MODE,
    ACTIVE_CONSUMER_ORDER_CHANGE_CURRENTPAGE,
    ACTIVE_CONSUMER_ORDER_SET_ORDER,
    CONSUMER_ORDER_RECEIVE,
    CONSUMER_ORDER_ERROR,
    CONSUMER_ORDER_CHANGE_MODE,
    CONSUMER_ORDER_CHANGE_CURRENTPAGE,
    CONSUMER_ORDER_SET_ORDER,
    ACTIVE_CONSUMER_ORDER_RECEIVE_ORDER,
    INVOICE_RECEIVE,
    INVOICE_ERROR,
    INVOICE_CHANGE_MODE,
    INVOICE_CHANGE_CURRENTPAGE,
    INVOICE_SET_ORDER,
    BACK_ORDERS_RECEIVE,
    BACK_ORDERS_ERROR,
    SHIPMENT_RECEIVE,
    SHIPMENT_ERROR,
    SHIPMENT_CHANGE_MODE,
    SHIPMENT_CHANGE_CURRENTPAGE,
    SHIPMENT_SET_ORDER,
    RETURN_LIST_RECEIVE,
    RETURN_LIST_ERROR,
    RETURN_LIST_CHANGE_MODE,
    RETURN_LIST_CHANGE_CURRENTPAGE,
    RETURN_LIST_SET_RETURN,
    RETURN_LIST_FILTER_CHANGE,
    RETURN_LIST_SET_SEARCH_TEXT,
    RETURN_LIST_SET_SORT_BY,
    RETURN_LIST_RECEIVE_CLOSED,
    RETURN_LIST_CHANGE_MODE_CLOSED,
    RETURN_LIST_CHANGE_CURRENTPAGE_CLOSED,
    RETURN_LIST_SET_RETURN_CLOSED,
    RETURN_LIST_FILTER_CHANGE_CLOSED,
    RETURN_LIST_SET_SEARCH_TEXT_CLOSED,
    RETURN_LIST_SET_SORT_BY_CLOSED,
    RETURN_RECEIVE_ORDER_ARTICLES,
    RETURN_RECEIVE,
    RETURN_CHANGE_MODE,
    RETURN_SET_ERROR,
    CREDIT_ORDER_RECEIVE,
    CREDIT_ORDER_ERROR,
    CREDIT_ORDER_CHANGE_MODE,
    CREDIT_ORDER_CHANGE_CURRENTPAGE,
    CREDIT_ORDER_SET_ORDER,
} from '../ConstantsBrafab/constants';

import { person as personReducer } from '../Reducers/Person.reducer';
import { address as addressReducer } from '../Reducers/Address.reducer';
import { order as orderReducer } from '../Reducers/Order.reducer';
import { invoice as invoiceReducer } from '../ReducersBrafab/Invoice.reducer';
import { activeConsumerOrder as activeConsumerOrderReducer } from '../ReducersBrafab/ActiveConsumerOrder.reducer';
import { consumerOrder as consumerOrderReducer } from '../ReducersBrafab/ConsumerOrder.reducer';
import { shipment as shipmentReducer } from '../ReducersBrafab/Shipment.reducer';
import { backOrder as backOrderReducer } from '../ReducersBrafab/BackOrderRowList.reducer';
import { returnAuthorization as returnReducer } from './ReturnAuthorization.reducer';
import { creditOrder as creditOrderReducer } from '../ReducersBrafab/CreditOrder.reducer';

const defaultState = {
    persons: {},
    addresses: {},
    backOrders: {},
    orders: {
        currentPage: 1,
    },
    invoices: {
        currentPage: 1,
    },
    consumerOrders: {
        currentPage: 1,
    },
    activeConsumerOrders: {
        currentPage: 1,
    },
    shipments: {
        currentPage: 1,
    },
    returns: {
        currentPage: 1,
        sortBy: '',
        sortDirection: 'asc',
        closedCurrentPage: 1,
        closedSortBy: '',
        closedSortDirection: 'asc',
    },
};

export const myPage = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PERSON_RECEIVE:
        case PERSON_ERROR:
        case PERSON_CHANGE_MODE:
            return {
                ...state,
                persons: personReducer(state.persons, action),
            };
        case ADDRESS_RECEIVE:
        case ADDRESS_ERROR:
        case ADDRESS_CHANGE_MODE:
            return {
                ...state,
                addresses: addressReducer(state.addresses, action),
            };
        case ORDER_RECEIVE:
        case ORDER_ERROR:
        case ORDER_CHANGE_MODE:
        case ORDER_CHANGE_CURRENTPAGE:
        case ORDER_SET_ORDER:
            return {
                ...state,
                orders: orderReducer(state.orders, action),
            };
        case CREDIT_ORDER_RECEIVE:
        case CREDIT_ORDER_ERROR:
        case CREDIT_ORDER_CHANGE_MODE:
        case CREDIT_ORDER_CHANGE_CURRENTPAGE:
        case CREDIT_ORDER_SET_ORDER:
            return {
                ...state,
                creditOrders: creditOrderReducer(state.creditOrders, action),
            };
        case RETURN_LIST_RECEIVE:
        case RETURN_LIST_ERROR:
        case RETURN_LIST_CHANGE_MODE:
        case RETURN_LIST_CHANGE_CURRENTPAGE:
        case RETURN_LIST_SET_RETURN:
        case RETURN_LIST_FILTER_CHANGE:
        case RETURN_LIST_SET_SEARCH_TEXT:
        case RETURN_LIST_SET_SORT_BY:
        case RETURN_LIST_RECEIVE_CLOSED:
        case RETURN_LIST_CHANGE_MODE_CLOSED:
        case RETURN_LIST_CHANGE_CURRENTPAGE_CLOSED:
        case RETURN_LIST_SET_RETURN_CLOSED:
        case RETURN_LIST_FILTER_CHANGE_CLOSED:
        case RETURN_LIST_SET_SEARCH_TEXT_CLOSED:
        case RETURN_LIST_SET_SORT_BY_CLOSED:
        case RETURN_RECEIVE_ORDER_ARTICLES:
        case RETURN_RECEIVE:
        case RETURN_CHANGE_MODE:
        case RETURN_SET_ERROR:
            return {
                ...state,
                returns: returnReducer(state.returns, action),
            };
        case INVOICE_RECEIVE:
        case INVOICE_ERROR:
        case INVOICE_CHANGE_MODE:
        case INVOICE_CHANGE_CURRENTPAGE:
        case INVOICE_SET_ORDER:
            return {
                ...state,
                invoices: invoiceReducer(state.invoices, action),
            };
        case ACTIVE_CONSUMER_ORDER_RECEIVE:
        case ACTIVE_CONSUMER_ORDER_ERROR:
        case ACTIVE_CONSUMER_ORDER_CHANGE_MODE:
        case ACTIVE_CONSUMER_ORDER_CHANGE_CURRENTPAGE:
        case ACTIVE_CONSUMER_ORDER_SET_ORDER:
        case ACTIVE_CONSUMER_ORDER_RECEIVE_ORDER:
            return {
                ...state,
                activeConsumerOrders: activeConsumerOrderReducer(state.activeConsumerOrders, action),
            };
        case CONSUMER_ORDER_RECEIVE:
        case CONSUMER_ORDER_ERROR:
        case CONSUMER_ORDER_CHANGE_MODE:
        case CONSUMER_ORDER_CHANGE_CURRENTPAGE:
        case CONSUMER_ORDER_SET_ORDER:
            return {
                ...state,
                consumerOrders: consumerOrderReducer(state.consumerOrders, action),
            };
        case SHIPMENT_RECEIVE:
        case SHIPMENT_ERROR:
        case SHIPMENT_CHANGE_MODE:
        case SHIPMENT_CHANGE_CURRENTPAGE:
        case SHIPMENT_SET_ORDER:
            return {
                ...state,
                shipments: shipmentReducer(state.shipments, action),
            };
        case BACK_ORDERS_RECEIVE:
        case BACK_ORDERS_ERROR:
            return {
                ...state,
                backOrders: backOrderReducer(state.backOrders, action),
            };
        default:
            return state;
    }
};
